import { darken, styled } from '@mui/system';
import { ButtonUnstyled } from '@mui/base';
import { theme } from 'src/utils';

export const ToolbarContainer = styled('header')<{
  position?: 'static' | 'relative' | 'absolute' | 'sticky' | 'fixed';
}>(({ position }) => ({
  display: 'flex',
  justifyContent: 'center',
  gap: '1rem',
  left: 0,

  '.group': {
    display: 'flex',
    border: '1px solid #596F93',
  },

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'unset',
    transform: 'none',
    position: position || 'inherit',
  },
}));

export const IconTextButtonContainer = styled(ButtonUnstyled)(() => ({
  backgroundColor: '#FFF',
  height: '2.4rem',

  display: 'flex',
  alignItems: 'center',
  padding: '0 .75rem',
  gap: '.5rem',

  border: '1px solid #596F93',

  '&:hover': {
    background: darken('#fff', 0.05),
  },

  cursor: 'pointer',

  transformOrigin: 'center',

  p: {
    whiteSpace: 'nowrap',
  },
}));

export const Button = styled(ButtonUnstyled, {
  shouldForwardProp: (prop) => prop !== 'noBorder' && prop !== 'isSmall' && prop !== 'isActive',
})(({ noBorder, isSmall }: any) => ({
  height: isSmall ? '2rem' : '2.4rem',
  width: isSmall ? '2.3rem' : '2.5rem',

  backgroundColor: '#FFF',

  cursor: 'pointer',

  '&:hover': {
    background: darken('#F6F6FA', 0.1),
  },

  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',

  border: noBorder ? 'none' : '1px solid #596F93',

  '.button-icon': {
    display: 'grid',
    placeItems: 'center',
    height: '1.5rem',
  },
}));
